export const mapVertices = (vertices, width, height) => {
    const res = vertices.map(item => {
        return { x: item.x * width, y: item.y * height };
    });
    return res;
};
export const mapDirections = (vertices, width, height) => {
    const res = { x: vertices.x * width, y: vertices.y * height, angle: vertices.angle };
    return res;
};
